import { firebase } from './../tools/tools';
import {Observable} from 'rxjs/Observable';
import { GenericModel } from './generic.model'

export class SubdomainModel extends GenericModel{

  /* ************************************************
  //Alta de los datos del dominio
  ************************************************ */
  createsubdomain( _subdomain: any){
    var id;

    if(!_subdomain.clave){
      id = firebase.database().ref("subdomains").push().key;
    }else{
      id = _subdomain.clave;
    }

    var subdomain:Subdomain = {
      nombre: _subdomain.nombre,
      url: _subdomain.url,
      usuario: _subdomain.user,
      password: _subdomain.psw,
      dominioPadre: _subdomain.dominioPadre,
      servidor: _subdomain.servidor,
      tipo: _subdomain.tipo,
      clave:id
    };

    //insertar objecto en un nodo
     firebase.database().ref(`subdomains/${id}`).set(subdomain).then( snapshot => {
    });
  }

  /* ************************************************
  //Borrar los datos del dominio
  ************************************************ */
  deletesubdomain(id: string){
    firebase.database().ref(`subdomains/${id}`).remove();
  }

  /* ************************************************
  //Obtener los datos del dominio
  ************************************************ */
  getsubdomain(){

    return new Observable<Array<Subdomain>>(observable => {
      var functionReturnValues = () => {
      firebase.database().ref("subdomains").once("value").then( snapshot => {
            if( snapshot.val() != null){
              var array = [];
                snapshot.forEach( child_snapshot => {
                    //console.log( child_snapshot.val())
                    var model = child_snapshot.val() as Subdomain;
                    array.push( model );
                });
                observable.next(array);
            }
        });
      }
      functionReturnValues();
      firebase.database().ref(`subdomains`).on('child_added', functionReturnValues);
      firebase.database().ref(`subdomains`).on('child_changed', functionReturnValues);
      firebase.database().ref(`subdomains`).on('child_removed', functionReturnValues);
    });
  }
}

export interface Subdomain{
  nombre:string;
  url:string;
  usuario:string;
  password:string;
  clave:string;
  dominioPadre?: string;
  servidor?: string;
  tipo:  string;
}
